import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@progress/kendo-react-buttons';
import { getAbortController } from './utils/abortController';
import './LoadingPanel.scss';

/**
 * Loading panel component
 * @module
 * @param {bool} isLoading - Is loading
 * @param {bool} [showAbort] - Show abort button for async requests
 */
const LoadingPanel = ({ isLoading, showAbort = false }) => {
  const abortController = getAbortController();
  if (isLoading) {
    return (
      <div className="k-loading-mask">
        <span className="k-loading-text">Loading</span>
        <div className="k-loading-image"></div>
        <div className="k-loading-color"></div>
        {showAbort && <div className="k-loading-abort-button"><Button fillMode="flat" onClick={() => abortController.abort()}>Zrušiť</Button></div>}
      </div>
    );
  } else {
    return null;
  }
}

LoadingPanel.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  showAbort: PropTypes.bool
}

export default LoadingPanel;